import {gql} from 'apollo-angular';

export const GET_GAME_TROPHIES = gql`
  query GetGameTrophies {
    getGameTrophies {
      trophyName
      description
      id
      trophyStatus
    }
  }
`;
